import sblog1 from '../../assets/image/sblog1.png';
import blog4 from '../../assets/image/blog4.png';

const dataSlider =[
    {
        id:1,
        imag:blog4
    },

    {
        id:2,
        imag:sblog1
    },
]

export default dataSlider